import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import DateRangeIcon from '@mui/icons-material/DateRange';
import Divider from '@mui/material/Divider';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import PropTypes from 'prop-types';
import React from 'react';
import SaveIcon from '@mui/icons-material/SaveOutlined';
import Tooltip from '@mui/material/Tooltip';
import {connect} from 'react-redux';
import {useTranslation} from 'react-i18next';

import {MODALS, TOUR_STAGES} from '@explorer/constants';
import {showFiltersPanel} from '@explorer/actions/sidebar';
import {showModal} from '@explorer/actions/ui';
import {trackEvent} from '@explorer/analytics';

const ActionsMenu = props => {
  const {t} = useTranslation();

  const onFiltersClick = () => {
    props.showFiltersPanel(true);
  };

  const onDateRangeClick = () => {
    trackEvent('Date range filter clicked');

    props.showModal(MODALS.DATE_RANGE);
  };

  const saveText = props.searchId
    ? t('actionsMenu.updateSearchButton', 'Update search')
    : t('actionsMenu.saveSearchButton', 'Save search');

  const onSaveSearchClick = () => {
    trackEvent(`${saveText} clicked`);
    props.showModal(MODALS.SAVE_SEARCH);
  };

  return (
    <Box
      width="100%"
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      data-tour={TOUR_STAGES.FILTERS}
    >
      <Tooltip title={t('actionsMenu.tooltipFilters')}>
        <Button
          color="inherit"
          fullWidth
          onClick={onFiltersClick}
          data-qe="filters-button"
          startIcon={<FilterAltOutlinedIcon />}
        >
          {t('actionsMenu.buttonFilters')}
        </Button>
      </Tooltip>
      <Divider orientation="vertical" variant="middle" flexItem sx={{mx: 1}} />
      <Tooltip title={t('actionsMenu.tooltipDateRanges')}>
        <Button
          fullWidth
          onClick={onDateRangeClick}
          data-qe="set-date-range-button"
          startIcon={<DateRangeIcon />}
        >
          {t('actionsMenu.buttonDateRanges')}
        </Button>
      </Tooltip>
      <Divider orientation="vertical" variant="middle" flexItem sx={{mx: 1}} />
      <Tooltip
        title={
          props.searchId
            ? t('actionsMenu.tooltipUpdateSearch')
            : t('actionsMenu.tooltipSaveSearch')
        }
      >
        <span>
          <Button
            fullWidth
            onClick={onSaveSearchClick}
            data-qe="click-save-search-button"
            startIcon={<SaveIcon />}
            disabled={!props.geometry}
            sx={{minWidth: 150}}
          >
            {saveText}
          </Button>
        </span>
      </Tooltip>
    </Box>
  );
};

ActionsMenu.propTypes = {
  showModal: PropTypes.func,
  showFiltersPanel: PropTypes.func,
  searchId: PropTypes.string,
  geometry: PropTypes.object,
};

const mapDispatchProps = {
  showModal,
  showFiltersPanel,
};

const mapStateToProps = state => ({
  searchId: state.search.id,
  geometry: state.search.geometry,
});

export default connect(mapStateToProps, mapDispatchProps)(ActionsMenu);
